import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../../components-v2/Theme/theme';

const {
	colors: { pill },
	spacing,
} = THEME;

export const styleSheet = StyleSheet.create({
	tooltipTriggerFade: {
		opacity: 0.5,
	},
	tooltipContent: {
		maxWidth: 280,
	},
	colorPickerTrigger: {
		gap: spacing.xs,
		alignItems: 'center',
	},
	colorPickerButton: {
		width: spacing.md,
		height: spacing.md,
		borderRadius: '50%',
	},
	colorPickerMenu: {
		gap: spacing.sm,
	},
	disabledTrigger: {
		cursor: 'not-allowed',
	},
	gray: {
		background: pill.gray.border,
	},
	blue: {
		background: pill.blue.border,
	},
	teal: {
		background: pill.teal.border,
	},
	green: {
		background: pill.green.border,
	},
	yellow: {
		background: pill.yellow.border,
	},
	orange: {
		background: pill.orange.border,
	},
	red: {
		background: pill.red.border,
	},
	pink: {
		background: pill.pink.border,
	},
	purple: {
		background: pill.purple.border,
	},
});
